import angular from 'angular';
import template from './failedVerificationModal.tpl.html';

const componentName = 'failedVerificationModal';

export default angular.module(componentName, []).component(componentName, {
  templateUrl: template,
});
